var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "max-w-7xl m-auto" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 1,
    class: "text-sm leading-5 text-gray-500"
};
const _hoisted_4 = { class: "italic text-curious-blue-500" };
import { appState } from '@/composable/appState';
import { useNotificationEvent } from '@/composable/Notification';
import { getFormattedDate } from '@/helper/helper';
import { i18n } from '@/plugin/vue-i18n';
import { ChatWidgetServices } from '@/service/ChatWidgetService';
import { WhatsappServices } from '@/service/WhatsappService';
import { PlusIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIEmpty, UIHeader, UIInput, UITable, UITag, UITextSmMedium, } from '@gohighlevel/ghl-ui';
import { computed, h, inject, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { CHAT_WIDGET_IDS, CHAT_WIDGET_ROUTES, ChatType, LIST_TABLE_KEYS, MODAL_DEFAULTS, TABLE_ACTION_KEYS, } from '../../helper/const';
import ChatTypeSelectorDialog from '../Modals/ChatTypeSelectorDialog.vue';
import ConfirmationModal from '../Modals/ConfirmationModal.vue';
import EmptyFigure from './../../assets/ListPage/EmptyFigure.vue';
import ListActions from './ListActions.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ListView',
    setup(__props) {
        const { sendNotification, handleError } = useNotificationEvent();
        const locale = inject('locale');
        const user = inject('user');
        const i18nInstance = useI18n();
        i18nInstance.locale.value = locale;
        // table refs
        const total = ref(0);
        const pageLimit = ref(10);
        const totalPages = computed(() => Math.ceil(total.value / pageLimit.value));
        const chatWidgets = ref([]);
        const loading = ref(false);
        const route = inject('route');
        const router = inject('router');
        const locationId = route.params.location_id;
        const page = ref(1);
        const showChatTypeSelectorDialog = ref(false);
        const selectedChatWidgetId = ref('');
        const modal = ref(MODAL_DEFAULTS);
        const showWhatsapp = ref(null);
        const waNumbers = ref([]);
        const startCount = ref();
        const endCount = ref();
        // clone refs
        const chatWidgetName = ref('');
        // Functions
        const pageChange = (val) => {
            page.value = val;
            fetchChatWidgets();
        };
        const fetchChatWidgets = () => __awaiter(this, void 0, void 0, function* () {
            checkWhatsappNumber();
            try {
                loading.value = true;
                const { data } = yield ChatWidgetServices.getChatWidgets(appState.locationId, {
                    limit: pageLimit.value,
                    offset: (page.value - 1) * pageLimit.value,
                });
                chatWidgets.value = (data === null || data === void 0 ? void 0 : data.chatWidgets) || [];
                total.value = data.totalCount;
                startCount.value = (page.value - 1) * pageLimit.value + 1;
                endCount.value = Math.min(page.value * pageLimit.value, total.value);
            }
            catch (error) {
                handleError(error);
            }
            finally {
                loading.value = false;
            }
        });
        onMounted(() => {
            appState.userId = user.id;
            appState.locationId = locationId;
            fetchChatWidgets();
        });
        const createChatWidget = (item) => __awaiter(this, void 0, void 0, function* () {
            try {
                loading.value = true;
                const data = yield ChatWidgetServices.createChatWidget({
                    locationId: appState.locationId,
                    default: false,
                    deleted: false,
                    version: 2,
                    name: 'Chat Widget' + (total.value + 1),
                    chatType: item === null || item === void 0 ? void 0 : item.type,
                    settings: {
                        chatType: item === null || item === void 0 ? void 0 : item.type,
                    },
                });
                if (data) {
                    sendNotification({
                        type: 'success',
                        title: i18n.global.t('listPage.successfullyCreated'),
                        description: i18n.global.t('listPage.chatWidgetHasBeenCreated'),
                    });
                    router.push({
                        name: CHAT_WIDGET_ROUTES.BUILDER_PAGE,
                        params: { location_id: appState.locationId, widgetId: data.data._id },
                    });
                }
                loading.value = false;
            }
            catch (error) {
                loading.value = false;
                handleError(error);
            }
        });
        function closeModals() {
            showChatTypeSelectorDialog.value = false;
        }
        function createNewSmsOrEmailChat(type = ChatType.EMAIL_CHAT) {
            return __awaiter(this, void 0, void 0, function* () {
                yield createChatWidget({ type });
                closeModals();
            });
        }
        function createNewLiveChat(type = ChatType.LIVE_CHAT) {
            return __awaiter(this, void 0, void 0, function* () {
                yield createChatWidget({ type });
                closeModals();
            });
        }
        function createNewWhatsappChat(type = ChatType.WA_CHAT) {
            return __awaiter(this, void 0, void 0, function* () {
                yield createChatWidget({ type });
                closeModals();
            });
        }
        const TABLE_MODALS = {
            DELETE: {
                id: CHAT_WIDGET_IDS.DELETE_CHAT_WIDGET_MODAL,
                type: 'error',
                title: i18n.global.t('listPage.deleteConfirmation'),
                message: i18n.global.t('listPage.areYouSureToDeleteChatWidget'),
                submitText: i18n.global.t('common.delete'),
                cancelText: i18n.global.t('common.cancel'),
            },
            CLONE: {
                id: CHAT_WIDGET_IDS.CLONE_CHAT_WIDGET_MODAL,
                type: 'primary',
                title: i18n.global.t('listPage.cloneConfirmation'),
                message: '',
                submitText: i18n.global.t('common.clone'),
                cancelText: i18n.global.t('common.cancel'),
            },
        };
        const handleActions = (action, id) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const name = (_a = chatWidgets.value.filter(chatWidget => chatWidget._id === id)) === null || _a === void 0 ? void 0 : _a[0].name;
            switch (action) {
                case TABLE_ACTION_KEYS.EDIT:
                    router.push({
                        name: CHAT_WIDGET_ROUTES.BUILDER_PAGE,
                        params: { location_id: appState.locationId, widgetId: id },
                    });
                    break;
                case TABLE_ACTION_KEYS.DELETE:
                    modal.value = Object.assign(Object.assign({}, TABLE_MODALS.DELETE), { loading: false, show: true, chatWidgetName: name });
                    chatWidgetName.value = name;
                    selectedChatWidgetId.value = id;
                    break;
                case TABLE_ACTION_KEYS.CLONE:
                    modal.value = Object.assign(Object.assign({}, TABLE_MODALS.CLONE), { loading: false, show: true, chatWidgetName: name });
                    chatWidgetName.value = name + ' - Clone';
                    selectedChatWidgetId.value = id;
                    break;
                default:
                    break;
            }
        });
        const resetModal = () => (modal.value = MODAL_DEFAULTS);
        const handleDelete = () => __awaiter(this, void 0, void 0, function* () {
            if (selectedChatWidgetId.value === '')
                return;
            modal.value.loading = true;
            try {
                yield ChatWidgetServices.deleteChatWidget(appState.locationId, selectedChatWidgetId.value);
                resetModal();
                if (chatWidgets.value.length === 1 && page.value > 1) {
                    page.value -= 1;
                }
                yield fetchChatWidgets();
                sendNotification({
                    type: 'success',
                    title: i18n.global.t('listPage.successfullyDeleted'),
                    description: i18n.global.t('listPage.chatWidgetHasBeenDeleted'),
                });
            }
            catch (error) {
                handleError(error);
                modal.value.loading = false;
                modal.value.show = false;
            }
        });
        const handleModalSubmit = () => __awaiter(this, void 0, void 0, function* () {
            switch (modal.value.id) {
                case CHAT_WIDGET_IDS.DELETE_CHAT_WIDGET_MODAL:
                    return handleDelete();
                case CHAT_WIDGET_IDS.CLONE_CHAT_WIDGET_MODAL:
                    return handleClone();
                default:
                    break;
            }
        });
        const handleClone = () => __awaiter(this, void 0, void 0, function* () {
            if (selectedChatWidgetId.value === '')
                return;
            modal.value.loading = true;
            try {
                yield ChatWidgetServices.cloneChatWidget({
                    locationId: appState.locationId,
                    chatWidgetId: selectedChatWidgetId.value,
                    name: chatWidgetName.value,
                });
                resetModal();
                yield fetchChatWidgets();
                sendNotification({
                    type: 'success',
                    title: i18n.global.t('listPage.successfullyCloned'),
                    description: i18n.global.t('listPage.chatWidgetHasBeenCloned'),
                });
            }
            catch (error) {
                handleError(error);
                modal.value.loading = false;
                modal.value.show = false;
            }
        });
        const tableColumns = [
            {
                title: i18n.global.t('listPage.name'),
                key: LIST_TABLE_KEYS.NAME,
                render: (row) => h(UITextSmMedium, {
                    onClick: () => handleActions(TABLE_ACTION_KEYS.EDIT, row[LIST_TABLE_KEYS.KEY]),
                    class: 'cursor-pointer',
                }, row[LIST_TABLE_KEYS.NAME]),
            },
            {
                title: i18n.global.t('listPage.updatedOn'),
                key: LIST_TABLE_KEYS.UPDATED_AT,
                render: (row) => getFormattedDate(row[LIST_TABLE_KEYS.UPDATED_AT]),
            },
            {
                title: i18n.global.t('listPage.chatType'),
                key: LIST_TABLE_KEYS.CHAT_TYPE,
                render: (row) => {
                    const chatType = row[LIST_TABLE_KEYS.CHAT_TYPE];
                    let displayText = null;
                    switch (chatType) {
                        case ChatType.LIVE_CHAT:
                            displayText = i18n.global.t('common.liveChat');
                            break;
                        case ChatType.EMAIL_CHAT:
                            displayText = i18n.global.t('common.smsOrEmailChat');
                            break;
                        case ChatType.WA_CHAT:
                            displayText = i18n.global.t('common.waChat');
                            break;
                        default:
                            displayText = null;
                    }
                    return displayText ? h(UITag, { type: 'info' }, displayText) : null;
                },
            },
            {
                title: '',
                key: LIST_TABLE_KEYS.ACTIONS,
                render: (row) => h(ListActions, {
                    onSelect: (val) => handleActions(val, row[LIST_TABLE_KEYS.KEY]),
                }, {}),
            },
        ];
        const checkWhatsappNumber = () => __awaiter(this, void 0, void 0, function* () {
            var _b;
            try {
                const whatsappNumber = yield WhatsappServices.getWhatsAppPhoneNumbersForLocationId(appState.locationId);
                const whatsappSubscription = yield WhatsappServices.getLocationSubscriptions(appState.locationId);
                const WANumbersData = (_b = whatsappNumber === null || whatsappNumber === void 0 ? void 0 : whatsappNumber.data) === null || _b === void 0 ? void 0 : _b.filter(el => (el === null || el === void 0 ? void 0 : el.status) == 'CONNECTED');
                const isSubscribed = whatsappSubscription === null || whatsappSubscription === void 0 ? void 0 : whatsappSubscription.data;
                if (WANumbersData.length > 0 && isSubscribed) {
                    showWhatsapp.value = true;
                    const WANumbersMap = WANumbersData.map(item => {
                        return {
                            label: item === null || item === void 0 ? void 0 : item.verifiedName,
                            value: item === null || item === void 0 ? void 0 : item.displayPhoneNumber.replace(/\D/g, ''),
                        };
                    });
                    waNumbers.value = WANumbersMap;
                }
                else {
                    showWhatsapp.value = false;
                }
            }
            catch (err) {
                console.error(err);
                showWhatsapp.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UIHeader), {
                    id: _unref(CHAT_WIDGET_IDS).LIST_HEADER,
                    title: _ctx.$t('common.pageTitle'),
                    description: _ctx.$t('common.pageDescription'),
                    "primary-action-icon": _unref(PlusIcon),
                    primaryText: _ctx.$t('common.new'),
                    onPrimaryClick: _cache[0] || (_cache[0] = ($event) => (showChatTypeSelectorDialog.value = true))
                }, null, 8 /* PROPS */, ["id", "title", "description", "primary-action-icon", "primaryText"]),
                _createVNode(_unref(UITable), {
                    id: _unref(CHAT_WIDGET_IDS).LIST_TABLE,
                    columns: tableColumns,
                    enableTextSearch: false,
                    pageCount: _unref(totalPages),
                    page: page.value,
                    "onUpdate:page": pageChange,
                    pageSize: pageLimit.value,
                    loading: loading.value,
                    data: chatWidgets.value
                }, {
                    empty: _withCtx(() => [
                        _createVNode(_unref(UIEmpty), {
                            id: _unref(CHAT_WIDGET_IDS).LIST_TABLE_EMPTY,
                            title: _ctx.$t('listPage.emptyTitle'),
                            description: _ctx.$t('listPage.emptyDescription'),
                            positiveText: _ctx.$t('common.new'),
                            "positive-icon": _unref(PlusIcon),
                            onPositiveClick: _cache[1] || (_cache[1] = ($event) => (showChatTypeSelectorDialog.value = true))
                        }, {
                            media: _withCtx(() => [
                                _createVNode(EmptyFigure)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["id", "title", "description", "positiveText", "positive-icon"])
                    ]),
                    "footer-left": _withCtx(() => [
                        _createVNode(_unref(UITextSmMedium), { class: "text-gray-700" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('listPage.pagination', { startCount: startCount.value, endCount: endCount.value, total: total.value })), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["id", "pageCount", "page", "pageSize", "loading", "data"]),
                _createVNode(ChatTypeSelectorDialog, {
                    show: showChatTypeSelectorDialog.value,
                    showWhatsapp: showWhatsapp.value,
                    locationId: _unref(appState).locationId,
                    loading: loading.value,
                    onCloseModal: closeModals,
                    onEmailChat: createNewSmsOrEmailChat,
                    onLiveChat: createNewLiveChat,
                    onWhatsappChat: createNewWhatsappChat
                }, null, 8 /* PROPS */, ["show", "showWhatsapp", "locationId", "loading"]),
                _createVNode(ConfirmationModal, {
                    id: modal.value.id,
                    show: modal.value.show,
                    type: modal.value.type,
                    title: modal.value.title,
                    chatWidgetName: modal.value.chatWidgetName,
                    loading: modal.value.loading,
                    "submit-text": modal.value.submitText,
                    "cancel-text": modal.value.cancelText,
                    onSubmit: handleModalSubmit,
                    onClose: _cache[3] || (_cache[3] = ($event) => (modal.value.show = false))
                }, {
                    default: _withCtx(() => [
                        (modal.value.id === _unref(CHAT_WIDGET_IDS).CLONE_CHAT_WIDGET_MODAL)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_unref(UIInput), {
                                    id: _unref(CHAT_WIDGET_IDS).CLONE_CHAT_WIDGET_MODAL_INPUT,
                                    label: _ctx.$t('common.name'),
                                    placeholder: _ctx.$t('listPage.enterChatWidgetName'),
                                    modelValue: chatWidgetName.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((chatWidgetName).value = $event))
                                }, null, 8 /* PROPS */, ["id", "label", "placeholder", "modelValue"])
                            ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                _createTextVNode(_toDisplayString(_ctx.$t('listPage.deleteConfirmationMessage1')) + " ", 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_4, _toDisplayString(chatWidgetName.value), 1 /* TEXT */),
                                _createTextVNode(". " + _toDisplayString(_ctx.$t('listPage.deleteConfirmationMessage2')), 1 /* TEXT */)
                            ]))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["id", "show", "type", "title", "chatWidgetName", "loading", "submit-text", "cancel-text"])
            ]));
        };
    }
});
